<template>
    <v-container fluid style="max-width: 640px">
        <h2 class="text-h6 mb-1">Profilo</h2>
        <div class="text-body-2 text-medium-emphasis mb-4">Gestisci i tuoi dati e la tua password</div>

        <v-card class="mb-4" variant="outlined">
            <v-card-title>I tuoi dati</v-card-title>
            <v-card-text>
                <v-form ref="formDatiRef">
                    <v-text-field :model-value="username" label="Username" disabled hide-details class="mb-4" />
                    <v-text-field v-model="formDati.displayName" label="Nome visualizzato" class="mb-4" />
                    <v-text-field v-model="formDati.eMail" label="Email" type="email" />
                </v-form>
            </v-card-text>
            <v-card-actions>
                <v-spacer />
                <v-alert v-if="messaggioDati" type="success" density="compact" variant="tonal" class="mr-2 py-1">
                    {{ messaggioDati }}
                </v-alert>
                <v-btn color="primary" :loading="salvandoDati" @click="salvaDati">Salva</v-btn>
            </v-card-actions>
        </v-card>

        <v-card variant="outlined">
            <v-card-title>Cambia password</v-card-title>
            <v-card-text>
                <v-form ref="formPasswordRef">
                    <v-text-field v-model="formPassword.passwordAttuale" type="password" label="Password attuale"
                        :rules="[v => !!v || 'Obbligatorio']" class="mb-4" />
                    <v-text-field v-model="formPassword.nuovaPassword" type="password" label="Nuova password"
                        :rules="[v => (!!v && v.length >= 8) || 'Almeno 8 caratteri']" class="mb-4" />
                    <v-text-field v-model="formPassword.confermaPassword" type="password" label="Conferma nuova password"
                        :rules="[v => v === formPassword.nuovaPassword || 'Le password non coincidono']" />
                </v-form>
                <v-alert v-if="erroreConfermaPassword" type="error" density="compact" variant="tonal" class="mt-3">
                    {{ erroreConfermaPassword }}
                </v-alert>
            </v-card-text>
            <v-card-actions>
                <v-spacer />
                <v-alert v-if="messaggioPassword" type="success" density="compact" variant="tonal" class="mr-2 py-1">
                    {{ messaggioPassword }}
                </v-alert>
                <v-btn color="primary" :loading="salvandoPassword" @click="cambiaPassword">Cambia password</v-btn>
            </v-card-actions>
        </v-card>
    </v-container>
</template>

<script>
export default {
    name: "ProfiloPage",

    data() {
        return {
            formDati: { displayName: "", eMail: "" },
            salvandoDati: false,
            messaggioDati: "",

            formPassword: { passwordAttuale: "", nuovaPassword: "", confermaPassword: "" },
            salvandoPassword: false,
            messaggioPassword: "",
            erroreConfermaPassword: "",
        };
    },

    computed: {
        username() {
            return this.$store.getters["user/getNome"];
        },
        mail() {
            return this.$store.getters["user/getMail"];
        },
        displayName() {
            return this.$store.getters["user/getDisplayName"];
        },
    },

    async mounted() {
        try {
            await this.$store.dispatch("user/userInfo");
        } catch (error) {
            console.log(error);
        }
        this.formDati = { displayName: this.displayName, eMail: this.mail };
    },

    methods: {
        async salvaDati() {
            if (!this.$refs.formDatiRef.validate()) return;
            this.messaggioDati = "";
            this.salvandoDati = true;
            try {
                await this.$store.dispatch("user/aggiornaProfilo", { ...this.formDati });
                this.messaggioDati = "Dati aggiornati.";
            } catch (error) {
                console.log(error);
            }
            this.salvandoDati = false;
        },

        async cambiaPassword() {
            this.erroreConfermaPassword = "";
            this.messaggioPassword = "";
            if (!this.$refs.formPasswordRef.validate()) return;

            this.salvandoPassword = true;
            try {
                await this.$store.dispatch("user/cambiaPassword", {
                    passwordAttuale: this.formPassword.passwordAttuale,
                    nuovaPassword: this.formPassword.nuovaPassword,
                });
                this.messaggioPassword = "Password aggiornata.";
                this.formPassword = { passwordAttuale: "", nuovaPassword: "", confermaPassword: "" };
                this.$refs.formPasswordRef.resetValidation();
            } catch (error) {
                this.erroreConfermaPassword = "Password attuale non corretta.";
                console.log(error);
            }
            this.salvandoPassword = false;
        },
    },
};
</script>
